import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { theme } from '../../themes/theme'
import { BoldMedBodyText } from '../styles/Text'

const bgColor = {
  paid: 'rgba(208, 112, 16, 0.1)',
  signing: 'rgba(208, 198, 16, 0.1)',
  ready: 'rgba(16, 208, 112, 0.1)',
  completed: 'rgba(16, 192, 208, 0.1)',
  rejected: 'rgba(58, 58, 58, 0.1)',
  expired: 'rgba(232, 85, 103, 0.1)'
}

const borderColor = {
  paid: 'rgba(208, 112, 16, 1)',
  signing: 'rgba(208, 198, 16, 1)',
  ready: 'rgba(16, 208, 112, 1)',
  completed: 'rgba(16, 192, 208, 1)',
  rejected: 'rgba(58, 58, 58, 1)',
  expired: 'rgba(232, 85, 103, 1)'
}

const Background = styled.div`
  display: flex;
  width: fit-content;

  color: #333;
  border: ${props => `1px solid ${borderColor[props.status]}`};
  background-color: ${props => bgColor[props.status]};
  border-radius: ${theme.borderRadius.button};
  padding: 8px 15px;
`

const WhiteBackground = styled(Background)`
  padding: 0;
  background-color: #fff;
`

const Status = styled(BoldMedBodyText)`
  text-transform: capitalize;
`

const PIRStatus = ({ status }) => (
  <WhiteBackground>
    <Background status={status.toLowerCase()}>
      <Status>{status.toLowerCase()}</Status>
    </Background>
  </WhiteBackground>
)

PIRStatus.propTypes = {
  status: PropTypes.oneOf(['PAID', 'SIGNING', 'READY', 'COMPLETED', 'REJECTED', 'EXPIRED']).isRequired
}

export default PIRStatus
